module.exports = __webpack_public_path__ + "static/Rajat Arora.fa3d02de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Rajat Arora.jpg
// module id = 1232
// module chunks = 6166952557895